import React, { useRef } from 'react';
var VeltCommentsSidebarV2List = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-list-v2", { ref: ref }, children));
};
export default VeltCommentsSidebarV2List;
